import { FadeUp, MaskedLine } from "./Reveal";

export default function SectionHeading({
    overline,
    title,
    lead,
    align = "left",
    testid,
}) {
    const alignCls = align === "center" ? "text-center mx-auto" : "text-left";
    return (
        <div className={`max-w-2xl ${alignCls}`} data-testid={testid}>
            {overline && (
                <FadeUp y={16}>
                    <p className="text-xs font-medium uppercase tracking-[0.28em] text-petrol">
                        {overline}
                    </p>
                </FadeUp>
            )}
            {title && (
                <h2 className="mt-4 font-serif text-3xl font-normal leading-[1.15] tracking-tight text-ink sm:text-4xl md:text-[2.75rem]">
                    <MaskedLine delay={0.1}>{title}</MaskedLine>
                </h2>
            )}
            {lead && (
                <FadeUp delay={0.25}>
                    <p className="mt-5 text-base font-light leading-relaxed tracking-wide text-body sm:text-lg">
                        {lead}
                    </p>
                </FadeUp>
            )}
        </div>
    );
}
